import {
    SET_RECEIVABLES_DATA,
    SET_RECEIVABLES_INVOICE_DATA,
    SET_RECEIVABLES_SUMMARY_COUNT,
    SET_RECEIVABLES_LOADER,
    SET_RECEIVABLES_FILTERS,
    SET_RECEIVABLES_PAGINATION,
    SET_PAYOUT_BUCKET_DATA,
    SET_INVOICE_MASTER_DATA,
    RESET_RECEIVABLES_DATA,
    SET_PAYOUT_EVENTS,
    PAYOUT_EVENTS_LOADING,
    PAYOUT_EVENTS_ERROR,
    SET_COMPUTATION_HEADERS_TO_SHOW,
} from 'src/common/actions/constants';

const defaultState = {
    loader: false,
    page_data: [],
    count: {},
    filters: {},
    pagination: {
        pageNumber: 1,
        resultPerPage: 10,
        nextOrPrev: 'first',
        isNextPresent: false,
    },
    payoutBuckets: {},
    payoutBucketColumns: {},
    masterDataBuckets: [],
    invoiceBuckets: {},
    invoiceBucketColumns: {},
    masterData: null,
    payoutEvents: {
        data: [],
        loading: false,
        error: null,
    },
    computationHeadersToShow: [],
    allowVendorsToAddAdhocCharge: false,
    isCnAggregationAtTrip: false,
    isVehicleLevelAggregation: false,
    isGroupedView: false,
    enableGlobalAddChargeOption: false,
    enableGlobalAddChargeSingleOption: false,
    hideVendorInvoiceTab: true,
    billingCycleType: null,
    billingCycleStart: null,
    views: [],
    viewSplitConfig: null,
    activeViewType: null,
    isPayoutMasterDataLoaded: false,
};

export default (state = defaultState, action) => {
    const { data } = action;
    switch (action.type) {
        case RESET_RECEIVABLES_DATA: {
            return {
                ...state,
                page_data: [],
            };
        }
        case SET_RECEIVABLES_LOADER: {
            return {
                ...state,
                loader: data,
            };
        }
        case SET_RECEIVABLES_DATA: {
            return {
                ...state,
                page_data: data?.payoutDataList || [],
                loader: false,
                pagination: {
                    ...state.pagination,
                    isNextPresent: data?.isNextPresent ?? false,
                },
            };
        }

        case SET_RECEIVABLES_INVOICE_DATA: {
            return {
                ...state,
                page_data: data?.invoiceDataList || [],
                loader: false,
                pagination: {
                    ...state.pagination,
                    isNextPresent: data?.isNextPresent ?? false,
                },
            };
        }

        case SET_RECEIVABLES_SUMMARY_COUNT: {
            return {
                ...state,
                count: data,
            };
        }

        case SET_RECEIVABLES_FILTERS: {
            return {
                ...state,
                filters: data,
            };
        }

        case SET_RECEIVABLES_PAGINATION: {
            const { pageNumber, resultPerPage, nextOrPrev, isNextPresent } = data || {};
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    pageNumber: pageNumber ?? 1,
                    resultPerPage: resultPerPage ?? 10,
                    nextOrPrev: nextOrPrev ?? state.pagination.nextOrPrev,
                    isNextPresent: typeof isNextPresent === 'boolean' ? isNextPresent : state.pagination.isNextPresent,
                },
            };
        }

        case SET_PAYOUT_BUCKET_DATA: {
            return {
                ...state,
                payoutBuckets: data?.payout_bucket_mapping || {},
                payoutBucketColumns: data?.payout_bucket_columns || {},
                payoutStatusFilterOptions: data?.payout_status_filter_options || [],
                allowVendorsToAddAdhocCharge: data?.allow_vendors_to_add_adhoc_charge || false,
                isCnAggregationAtTrip: data?.is_cn_aggregation_at_trip || false,
                isVehicleLevelAggregation: data?.is_vehicle_level_aggregation || false,
                isGroupedView: data?.is_grouped_view || false,
                enableGlobalAddChargeOption: data?.enable_global_add_charge_option || false,
                enableGlobalAddChargeSingleOption:
                    data?.enable_global_add_charge_single_option || false,
                hideVendorInvoiceTab: data?.hide_vendor_invoice_tab !== false,
                billingCycleType: data?.billing_cycle_type,
                billingCycleStart: data?.billing_cycle_start,
                views: data?.views || [],
                viewSplitConfig: data?.view_split_config,
                activeViewType: data?.active_view_type,
                isPayoutMasterDataLoaded: true,
                loader: false,
            };
        }

        case SET_INVOICE_MASTER_DATA: {
            return {
                ...state,
                masterData: data,
                invoiceBuckets: data?.invoice_bucket_mapping || {},
                invoiceBucketColumns: data?.invoice_bucket_columns || {},
            };
        }

        case PAYOUT_EVENTS_LOADING: {
            return {
                ...state,
                payoutEvents: {
                    ...state.payoutEvents,
                    loading: true,
                    error: null,
                },
            };
        }

        case SET_PAYOUT_EVENTS: {
            const newState = {
                ...state,
                payoutEvents: {
                    data: data || [],
                    loading: false,
                    error: null,
                },
            };
            return newState;
        }

        case PAYOUT_EVENTS_ERROR: {
            return {
                ...state,
                payoutEvents: {
                    ...state.payoutEvents,
                    loading: false,
                    error: data,
                },
            };
        }

        case SET_COMPUTATION_HEADERS_TO_SHOW: {
            return {
                ...state,
                computationHeadersToShow: data || [],
            };
        }

        default:
            return state;
    }
};
